/**
 *
 * Body2
 *
 */

import { Typography, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

import styles from './styles';

/**
 *  @deprecated
 *  @example
 *
 *  Use `Typography` from `@material-ui/core` instead.
 *
 *  ```
 *  <Typography variant="body2" />
 *  ```
 */
function Body2({
  classes,
  children,
  // eslint-disable-next-line no-unused-vars
  color,
  align,
  component,
  display,
  gutterBottom,
  noWrap,
  paragraph,
}) {
  const { root } = classes;
  return (
    <Typography
      align={align}
      classes={classes}
      className={root}
      component={component}
      display={display}
      gutterBottom={gutterBottom}
      noWrap={noWrap}
      paragraph={paragraph}
      variant="body2"
    >
      {children}
    </Typography>
  );
}

Body2.propTypes = {
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  classes: PropTypes.object.isRequired,
  // color prop is passed into styles.js
  // it is undefined if nothing is passed into it, not default prop
  color: PropTypes.string,

  component: PropTypes.elementType,

  display: PropTypes.oneOf(['initial', 'block', 'inline']),

  gutterBottom: PropTypes.bool,

  noWrap: PropTypes.bool,

  paragraph: PropTypes.bool,
};

Body2.defaultProps = {
  align: 'inherit',
  // default color prop only for convention, does not affect style
  color: 'gray600',

  display: 'initial',

  gutterBottom: false,

  noWrap: false,

  paragraph: false,
};

export default withStyles(styles)(memo(Body2));
